export default function MissingComponent({ name }: { name: string }) {
  return (
    <div className="relative w-full max-w-full rounded-md p-1 shadow-lg">
      <div
        className="pointer-events-none absolute inset-0 rounded-md opacity-80"
        style={{
          background: 'repeating-linear-gradient(-45deg, #111111 0 10px, #fbbf24 10px 20px)',
        }}
        aria-hidden="true"
      />
      <div className="relative flex w-full max-w-full items-start gap-3 rounded-sm border-2 border-black bg-amber-50 p-4 text-amber-900">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-black text-amber-300 font-semibold shadow">
          !
        </div>
        <div className="min-w-0 space-y-1">
          <div className="text-sm text-amber-900 break-words">
            Could not render <code className="font-mono text-black">{name}</code>. Check the{' '}
            <code>data-react-component</code> attribute and entrypoint exports.
          </div>
        </div>
      </div>
    </div>
  )
}
